import { Component, OnInit } from '@angular/core';
import { MyToasterService } from '../../../../services/my-toaster.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IncorporadoraAPI } from '../../../../api/incorporadora.api';
import { LoadingService } from '../../../../services/loading.service';
import { EmpreendimentosAPI } from '../../../../api/empreendimento.api';
import { EdificiosAPI } from '../../../../api/edificios.api';
import { UnidadesAPI } from '../../../../api/unidades.api';
import { ProcessAPI } from '../../../../api/process.api';
import { IncorporadoraHeaderService } from '../../../../services/incorporadora-header.service';
// import { EmpreendimentosAPI } from '../../../../api/empreendimento.api';

@Component({
	selector: 'incorporadoras-app-modal',
	templateUrl: './incorporadoras-modal.component.html',
	styleUrls: ['./incorporadoras-modal.component.scss']
})
export class IncorporadorasModalComponent implements OnInit {

	public dados: any = {
		incorporadoras: [],
		empreendimentos: [],
		edificios: [],
		unidades: []
	};
	public incorporadorasArray = [];
	public empreendimentosArray = [];
	public edificiosArray = [];
	public unidadesArray = [];
	public processoId = 0;
	constructor(private myToaster: MyToasterService,
		private activeModal: NgbActiveModal,
		public incorporadorasAPI: IncorporadoraAPI,
		private loadingService: LoadingService,
		private empreendimentoAPI: EmpreendimentosAPI,
		private edificiosAPI: EdificiosAPI,
		private unidadesAPI: UnidadesAPI,
		private processAPI: ProcessAPI,
		private incorporadoraHeaderService: IncorporadoraHeaderService) { }

	async ngOnInit() {
		this.dados['processoId'] = this.processoId;
		//Load incorporadoras
		await this.getIncorporadora();

	}
	/**
 * onSubmit
 *
 * Método chamado na tentativa de submissão do formulário
 *
 * @protected
 * @author Nicolas Aoki
 * @since  11/2019
 * @param  {object}
 * @return {void}
 */
	public async onSubmit() {
		try {
			this.myToaster.showLoading('Vinculando dados...');
			await this.processAPI.updateProcess(this.dados);
			//Aciona o recarregamento da varialem em process-header
			//para fazer uma requisicao e mostrar a incorporadora adicionada no header
			this.incorporadoraHeaderService.incorporadoraNovaAdicionada();
			this.activeModal.close();
			this.myToaster.hideLoading();
		} catch (err) {
			this.myToaster.hideLoading();
			this.myToaster.showErrorToast('Não foi possivel efetuar a transação', err);
		}
	}
	async getIncorporadora(e?) {
		this.incorporadorasArray = []
		await this.incorporadorasAPI.getByIncorporadoraName(e).then((dados) => {
			for (let index = 0; index < dados.data.length; index++) {
				this.incorporadorasArray.push({ value: dados.data[index].Nome, id: dados.data[index].IncorporadoraId });
			}
		})
	}
	async getEmpreendimento(e?) {

		this.empreendimentosArray = [];
		await this.empreendimentoAPI.getByIncorporadoraId({id:this.dados.incorporadoras,nomeEmpreendimento:e}).then((dados) => {
			for (let index = 0; index < dados.data.length; index++) {
				this.empreendimentosArray.push({ value: dados.data[index].Nome, id: dados.data[index].EmpreendimentoId });
			}
		})
	}
	async getEdificios(e?) {
		this.edificiosArray = [];
		await this.edificiosAPI.getByEmpreendimentoId({id:this.dados.empreendimentos,nomeEdificio:e}).then((dados) => {
			for (let index = 0; index < dados.data.length; index++) {
				this.edificiosArray.push({ value: dados.data[index].Nome, id: dados.data[index].EdificioId });
			}
		})
	}
	async getUnidades(e?) {
		this.unidadesArray = [];
		await this.unidadesAPI.getByEdificio({id:this.dados.edificios,nomeUnidade:e}).then((dados) => {
			for (let index = 0; index < dados.data.length; index++) {
				this.unidadesArray.push({ value: dados.data[index].Nome, id: dados.data[index].UnidadeId });
			}
		})
	}
	public close() {
		this.activeModal.close();
	}

}



// WEBPACK FOOTER //
// ./src/app/pages/incorporadoras/modal/incorporadoras-modal.component.ts